import GetMedia from '@/connection/greenroom/get-media';
import LoadGraphics from '@/connection/greenroom/load-graphics';
import LoadGreenroomShots from '@/connection/greenroom/load-greenroom-shots';
import { ProjectStateReducerCreator } from '../types';

const loadGreenroomDataReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ meetingId, token }: { meetingId: number; token: string }, { rejectWithValue }) => {
      if (!token) {
        return rejectWithValue('No ID Token');
      }

      if (!meetingId) {
        return rejectWithValue('No Meeting ID');
      }

      return Promise.allSettled([LoadGreenroomShots(meetingId), GetMedia(meetingId), LoadGraphics(meetingId, token)]);
    },
    {
      fulfilled: (state, action) => {
        const [shotsRes, mediaRes, graphicsRes] = action.payload;
        if (shotsRes.status !== 'fulfilled' || !Array.isArray(shotsRes.value)) {
          state.greenroomShotsError = true;
        } else {
          state.greenroomShots = shotsRes.value.toSorted((a, b) => a.shot_data.order - b.shot_data.order);
          state.greenroomShotsError = false;
        }

        if (mediaRes.status !== 'fulfilled' || !Array.isArray(mediaRes.value)) {
          state.greenroomMediaError = true;
        } else {
          state.greenroomMedia = mediaRes.value;
          state.greenroomMediaError = false;
        }

        if (graphicsRes.status !== 'fulfilled' || !Array.isArray(graphicsRes.value)) {
          state.greenroomGraphicsError = true;
        } else {
          state.greenroomGraphics = graphicsRes.value;
          state.greenroomGraphicsError = false;
        }
      },
      pending: (state) => {
        state.greenroomMediaLoading = true;
        state.greenroomShotsLoading = true;
        state.greenroomGraphicsLoading = true;
      },
      settled: (state) => {
        state.greenroomMediaLoading = false;
        state.greenroomShotsLoading = false;
        state.greenroomGraphicsLoading = false;
      },
      rejected: (state, action) => {
        console.error(action);
        state.greenroomMediaError = true;
        state.greenroomShotsError = true;
        state.greenroomGraphicsError = true;
      },
    }
  );
};

export default loadGreenroomDataReducer;
